import * as XLSX from 'xlsx';
import dayjs from 'dayjs';

export const exportToExcel = (excelData, columnWidths, sheetName, fileNamePrefix) => {
  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  if (columnWidths && columnWidths.length > 0) {
    worksheet['!cols'] = columnWidths;
  }

  const fileName = `${fileNamePrefix}_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};

